import { PATH_EVALUATION360, PATH_EVALUATION360_INFORM } from "@/constants/URL";
import routerWithSidebar from "./routerWithSidebar";
export default [
  {
    path: PATH_EVALUATION360,
    redirect: PATH_EVALUATION360_INFORM,
    components: routerWithSidebar(() =>
      import(/* webpackChunkName: "role" */ "@/views/evaluation360/index.vue")
    ),
    children: [
      {
        path: PATH_EVALUATION360_INFORM,
        components: routerWithSidebar(() =>
          import(/* webpackChunkName: "role" */ "@/views/evaluation360/inform/index.vue")
        )
      }
    ]
  }
];
